import { Link } from "react-router-dom";
import { MASCOT_FACE_URL, PACKAGES } from "@/config/brand";
import { useTracking } from "@/hooks/useTracking";

const Footer = () => {
  const { withTracking } = useTracking();
  return (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-[#071735] text-white">
      <div className="mx-auto max-w-5xl px-5 py-14 md:px-10 md:py-16">
        <div className="flex flex-col gap-10 md:flex-row md:items-start md:justify-between">
          <div className="max-w-sm">
            <div className="flex items-center gap-3">
              <img
                src={MASCOT_FACE_URL}
                alt="Same Day Home Services"
                width={48}
                height={48}
                className="rounded-full border-2 border-sdh-sky/60"
              />
              <div>
                <p className="text-[10px] font-bold uppercase tracking-[0.22em] text-sdh-sky">
                  Same Day
                </p>
                <p className="font-display text-xl uppercase tracking-[0.04em]">Home Services</p>
              </div>
            </div>
            <p className="mt-5 text-sm leading-relaxed text-white/60">
              Fixed-price bathroom renovations by a fully licensed NSW company with all trades
              in-house — no subcontractors, no bluff. One clear price, confirmed upfront.
            </p>
            <p className="mt-4 flex items-center justify-center gap-1 text-lg font-bold text-[#FFC107]">
              ★★★★★ <span className="ml-1 text-sm font-semibold text-sdh-sky">600+ 5-star Google reviews</span>
            </p>
          </div>
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-sdh-sky">Packages</p>
            <ul className="mt-4 space-y-2.5 text-sm">
              {Object.values(PACKAGES).map((p) => (
                <li key={p.id}>
                  <Link
                    to={withTracking(p.route)}
                    data-testid={`footer-link-${p.id}`}
                    className="text-white/70 transition-colors duration-300 hover:text-sdh-sky"
                  >
                    {p.name} — {p.price}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-sdh-sky">
              Service Area
            </p>
            <p className="mt-4 text-sm leading-relaxed text-white/70">
              Sydney Wide
              <br />
              Metro & Greater Sydney, NSW
            </p>
          </div>
        </div>
        <div className="mt-12 flex flex-col items-center gap-2 border-t border-white/10 pt-6 text-center text-xs text-white/40 md:flex-row md:items-center md:justify-between md:text-left">
          <p data-testid="footer-copyright">
            © {new Date().getFullYear()} Same Day Home Services · Lic. 370656C · Sydney, NSW
          </p>
          <p>Fixed-price bathroom renovations.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
